export default __webpack_public_path__ + "static/media/THEME.cef4aa01.png";